import React from "react";
import { Card } from "react-bootstrap";
import "./addBox.css";
import RiskBar from "../../components/RiskbarLevel/RiskBar";

const AddBox = ({
  item,
  isDarkMode,
  handleAddToBattleClick,
  handlePlusClick,
  handleMinusClick,
  imageContainerClass
}) => {
  return (
    <div className={`addbox-card-container ${isDarkMode ? "dark" : ""}`}>
     <Card className={`addbox-card ${isDarkMode ? "dark" : "light"} ${isDarkMode && item.quantity > 0 ? "has-quantity" : ""}`}> 
         {/* Card Image */}
        <div  className={`card-image-container ${imageContainerClass}`}>
          <Card.Img
            className="card-image"
            // variant="top"
            src={`${item?.box_images ? item?.box_images?.image : item?.image}`}
            alt={item?.name}
          />
        </div>

        {/* Card Content */}
        <div>
          <Card.Title className="card-title-box">{item?.name}</Card.Title>

          {/* Price */}
          <div className="price-container">
            <span className="price-amount">
              ${item?.box_price ? item?.box_price : item?.price}
            </span>
          </div>
        </div>

        <div className="card-controls">
          {item.quantity > 0 ? (
            <div className="quantity-controls">
              <button
                type="button"
                className={`quantity-btn minus-btn ${isDarkMode ? "minus-btn-dark" : "minus-btn-light"}`}
                onClick={() => handleMinusClick(item.id)}
                disabled={item.quantity <= 0}
              >
                −
              </button>
              <span className="quantity-display">{item?.quantity || 0}</span>
              <button
                type="button"
                className={`quantity-btn plus-btn ${isDarkMode ? "plus-btn-dark" : "plus-btn-light"}`}
                onClick={() => handlePlusClick(item.id)}
              >
                +
              </button>
            </div>
          ) : (
            <button
              type="button"
              className="add-to-battle-btn"
              onClick={() => handleAddToBattleClick(item.id)}
            >
              Add Box
            </button>
          )}
        </div>
      </Card>
    </div>
  );
};

export default AddBox;